import React, {useState} from 'react';
import { Icon, Button } from '../../Atoms';
function TemplateRembourcementHistory(props) {
    const [open, setOpen] = useState(false)
    return (
        <>
            <div style={{ marginTop: '50px' }} >
                <div className='history-simulateur-rembourse-line-container' onClick={() => setOpen(!open)} >
                    <div className='history-simulateur-rembourse-icon-container' >
                        <Icon icon='Telechargement' size={'20px'} />
                    </div>
                    <div className='first-text-and-second-text-simulateur-remboursement'>
                        <div className='history-simulateur-rembourse-text1'>
                            Eva ROBIN -  16/08/2021
                        </div>
                        <div className='history-simulateur-rembourse-text2'>
                            Eva ROBIN -  16/08/2021
                        </div>
                    </div>
                    <div className='history-simulateur-rembourse-text3'>
                        450 €
                    </div>
                    <div className='history-simulateur-rembourse-sort-icon-container'>
                        <Icon icon={open ? 'SortTop' : 'Sort'} size={'18px'} />
                    </div>
                </div>
                {open && <>
                <div className='history-simulateur-rembourse-line-container'>
                    <div className='history-simulateur-rembourse-text4'>
                        Eva ROBIN -  16/08/2021
                    </div>
                    <div className='history-simulateur-rembourse-text3'>
                        450 €
                    </div>
                </div>
                <div className='history-simulateur-rembourse-line-container'>
                    <div className='history-simulateur-rembourse-text4'>
                        Eva ROBIN -  16/08/2021
                    </div>
                    <div className='history-simulateur-rembourse-text3'>
                        450 €
                    </div>
                </div>
                </>}
            </div>
            <div className='btn-next-container-simulateur-remboursement'>
                <Button
                    text='Nouvelle demande'
                    className={'btn-download-simulateur-remboursement'}
                />
            </div>
        </>
    );
}

export default TemplateRembourcementHistory;
